import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/hourly-rate-calculator',
  component: () => import('../../routes/HourlyRateCalculator.svelte'),
  card: {
    id: 'hourly-rate-calculator',
    title: 'Hourly Rate Calculator',
    description: 'Convert hourly wage to annual, monthly, weekly, and daily income with custom work schedule.',
    icon: 'schedule',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/hourly-rate-calculator',
    category: 'Life & Budget',
  },
  seo: {
    title: 'Hourly Rate Calculator – Convert Hourly Wage to Annual Salary',
    description: 'Free hourly rate calculator: instantly convert your hourly wage to annual, monthly, biweekly, weekly, and daily income. Adjust for part-time, overtime, and custom work schedules.',
  },
};

export default meta;
